import { Component, OnInit } from '@angular/core';
import { text } from 'src/services/text.service';
import { Model } from 'src/logic/model';
import { Actions } from 'src/logic/enum/actions';
import { Act } from 'src/logic/act';
import { Utilits } from 'src/logic/utilits';

@Component({
    selector: 'app-code',
    templateUrl: './code.component.html',
    styleUrls: ['./code.component.less'],
    standalone: false
})
export class CodeComponent implements OnInit {

  constructor(public model: Model, public act: Act) { }

  Actions = Actions;
  Utilits = Utilits;
  
  text = text;

  nameCamel: string = "";
  nameKebab: string = "";

  blockTextReplacingPatternsVis: boolean = true;

  ngOnInit(): void {

  }

  copypastePalettePatterns() {
    return this.model.copypastePalette.filter(it => it.isPattern);
  }

  nameCamelKeyup(){
    let kebab = "";
    for (let i = 0; i < this.nameCamel.length; i++) 
    {
      const ch = this.nameCamel.charAt(i);
      if(/[A-Z]/.test(ch))
        {
        kebab += i > 0
                  ? '-'+ch.toLowerCase()
                  : ch.toLowerCase();
        }
      else
      {
        kebab += ch;
      }
    }
    this.nameKebab = kebab;
  }

  nameKebabKeyup(){
    let camel = "";
    for (let i = 0; i < this.nameKebab.length; i++) {
      if(this.nameKebab[i]=='-')
      {
        if((i+1)<this.nameKebab.length)
        {
          camel+=this.nameKebab[i+1].toUpperCase();
          i += 1;
          continue;
        }
      } 
      else 
      {
        camel+=this.nameKebab[i];
      }
    }
    this.nameCamel = camel;
  }

  ///methods

  processPattern(pattern: string = "...."){
    if(!this.nameCamel && !this.nameKebab)
    {
      return pattern;
    }
    return pattern.replace(/\.\.CamelFirstLower\.\./i,this.firstLetterLower(this.nameCamel))
      .replace(/\.\.CamelFirstUpper\.\./i,this.firstLetterUpper(this.nameCamel))
      .replace(/\.\.Kebab\.\./i,this.nameKebab);

  }

  firstLetterLower(value: string): string{
    if(value.length > 0)
    {
      return value.substring(0,1).toLowerCase() + value.substring(1);
    }
    else 
    {
      return "";
    }
  }

  firstLetterUpper(value: string): string{
    if(value.length > 0)
      return value.substring(0,1).toUpperCase() + value.substring(1);
    else
      return "";
  }
}
